import * as Loadable from 'react-loadable'

import fetchSearchResults, {
  onBeforeSearchPageView
} from '../../../common/actions/searchPage'
import { IPageComponent } from '../../../typings/pageComponent'
import LoadingCover from '../../components/loadingCover'

const SearchPageLoadableContainer = (Loadable as any)({
  loader: () =>
    import(/* webpackChunkName: "searchPage" */ './searchPageContainer'),
  loading: LoadingCover,
  webpack: () => [require.resolveWeak('./searchPageContainer')],
  modules: ['./searchPageContainer']
}) as IPageComponent<any>

SearchPageLoadableContainer.loadData = (
  store,
  location,
  apiUrlPrefix,
  routeMatch
) => store.dispatch(fetchSearchResults(location, apiUrlPrefix, routeMatch))

SearchPageLoadableContainer.onBeforePageView = (store, location, routeMatch) =>
  store.dispatch(onBeforeSearchPageView(location, routeMatch))

export default SearchPageLoadableContainer
